import { formatCurrency } from "@/utils/valueFormat";

type CurrencyCellProps = {
  value?: number;
  secondaryValue?: number;
};

const CurrencyCell = ({ value, secondaryValue }: CurrencyCellProps) => {
  return (
    <div style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
      {secondaryValue !== undefined && (
        <span style={{ textDecoration: "line-through", opacity: 0.5 }}>
          {formatCurrency(secondaryValue)}
        </span>
      )}
      <span>{value !== undefined && formatCurrency(value)}</span>
    </div>
  );
};

export default CurrencyCell;
